import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import EditorPage from '@/views/EditorPage.vue'
import MainPage from '@/views/MainPage.vue'
import AdminPage from '@/views/Admin/index.vue' 
import JsonEditor from '@/views/JsonEditor.vue' 

const routes = [
  { path: '/', component: MainPage },
  { path: '/editor', component: EditorPage, meta: { requiresAuth: true } },
  { path: '/admin', component: AdminPage },
  { path: '/json-editor', component: JsonEditor }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token') 

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/admin')
  } else {
    next()
  }
})

export default router
